'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Container": "Polaris-IndexFilters-Container"
};

exports.default = styles;
